import { render, staticRenderFns } from "./PersCalendar.vue?vue&type=template&id=0844270a&"
import script from "./PersCalendar.vue?vue&type=script&lang=js&"
export * from "./PersCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PersCalendar.vue?vue&type=style&index=0&id=0844270a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports